// Planos exibidos no autocadastro. O valor/preço final é autoridade do backend
// (getValorMensalidade); aqui é só apresentação. Mapeiam para o enum PlanoAssinatura.
export const PLANOS_ONBOARDING = [
    {
        value: "PLANO1",
        nome: "Básico",
        preco: 127,
        resumo: "O essencial para começar a vender.",
        features: [
            "Frente de caixa (PDV)",
            "Cardápio Digital",
            "ChatBot Simplificado",
            "Cupons de Desconto",
            "Suporte por WhatsApp",
        ],
    },
    {
        value: "PLANO2",
        nome: "Intermediário",
        preco: 227,
        recomendado: true,
        resumo: "O mais escolhido — operação completa de delivery.",
        features: [
            "Tudo do Básico",
            "Programa de Fidelidade",
            "Marketing Automatizado",
            "Integração com iFood",
            "Gestão de Entregadores",
            "Pixel da Meta",
            "QR Code para pedidos de mesa",
            "Pesquisa de satisfação automatizada",
            "ChatBot Completo",
        ],
    },
    {
        value: "PLANO3",
        nome: "Avançado",
        preco: 327,
        resumo: "Operação completa com emissão fiscal e IA.",
        features: [
            "Tudo do Intermediário",
            "Integração com PDVs",
            "Emissão Fiscal",
            "ChatBot com IA",
        ],
    },
]
